module.exports = __webpack_public_path__ + "static/media/expert2.b8003f09.png";